var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-placeholder"},[_c('div',{staticClass:"loading-icon",style:(_vm.styles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }